import gql from "graphql-tag";

export const ADD_UPDATE_CREW_RESOURCE_MUTATION = gql`
  mutation addCrewResources($where: AddEditCrewResourcesInput!){
    addCrewResources(where: $where)
  }
`;